import axios from "axios";
import Swal from 'sweetalert2';

const state = {
  topupsList: [], 
  topupArr: [],
  topupArray: [],
  topupID: '',
  isEditing: false
};
  
const mutations = {
  initializeStore(state){
    state.topupsList = [];
    state.topupArr = [];
    state.topupArray = [];
    state.topupID = "";
    state.isEditing = false;
  },

  LIST_TOPUPS(state, topup) {
    state.topupsList = topup;
  },
  TOPUPS_ARRAY(state, topups){
    state.topupArray = topups;
  },
  
  SET_STATE(state, payload) {
    for (const key in payload) {
        if (payload.hasOwnProperty(key) && key in state) {
            state[key] = payload[key];
        }
    }
  },
  SET_SEARCH_FILTERS(state, search_filter){
    for(const [key, value] of Object.entries(search_filter)){
    
    }
  },
  RESET_SEARCH_FILTERS(state){

  }
};
  
const actions = {
  updateState({ commit }, newState) {
    commit('SET_STATE', newState);
  },
  
  async createLoanTopup({ commit,state }, formData) {
    return axios.post('api/v1/create-employee-loan-topup/', formData)
    .then((response)=>{
      return response;
    })
    .catch((error)=>{
      console.log(error.message);
      throw error;
    })
  },

  fetchLoanTopups({ commit,state }, formData) {
    state.topupArr = [];
    axios.post(`api/v1/get-employee-loan-topups/`,formData)
    .then((response)=>{
      for(let i=0; i< response.data.length; i++){
        state.topupArr.push((response.data[i].journal.journal_no + " - " + response.data[i].loan_application.loan_number));
      }
      commit('LIST_TOPUPS', response.data);
    })
    .catch((error)=>{
      console.log(error.message);
    })
    
  },
  fetchLoanTopup({ commit,state }, formData) {
    axios.post(`api/v1/get-employee-loan-topups/`,formData)
    .then((response)=>{
      
    })
    .catch((error)=>{
      console.log(error.message);
    })
    
  },
  handleSelectedTopup({ commit, state }, option){
    
      
  },

  async updateLoanTopup({ commit,state }, formData) {
    return axios.put(`api/v1/update-employee-loan-topup/`,formData)
    .then((response)=>{
      return response;
    })
    .catch((error)=>{
      console.log(error.message);
      throw error;
    })  
  },

  deleteLoanTopup({ commit,state }, formData) {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you wish to delete Loan Topup?`,
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes Delete Loan Topup!',
      cancelButtonText: 'Cancel!',
      customClass: {
          confirmButton: 'swal2-confirm-custom',
          cancelButton: 'swal2-cancel-custom',
      },
      showLoaderOnConfirm: true,
    }).then((result) => {
      if (result.value) {
        axios.post(`api/v1/delete-employee-loan-topup/`,formData)
        .then((response)=>{
          if(response.status == 200){
              Swal.fire("Poof! Loan Topup removed succesfully!", {
                icon: "success",
              }); 
          }else{
            Swal.fire({
              title: "Error Deleting Loan Topup",
              icon: "warning",
            });
          }                   
        })
        .catch((error)=>{
          console.log(error.message);
          Swal.fire({
            title: error.message,
            icon: "warning",
          });
        })
      }else{
        Swal.fire(`Loan Topup has not been deleted!`);
      }
    })
  },
};
  
const getters = {
  // users: (state) => state.users,
  // currentUser: (state) => state.currentUser,
};
  
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
  
  